import React, { FC } from 'react';
import { HeaderFooter } from './HeaderFooter';
import styled from 'styled-components/macro';

export const FooterBar: FC<{ className?: string }> = ({ className }) => (
    <Footer className={className}>
        <div className="grid-content left-content">
            <span>
                <a href="https://outthink.io/privacy-policy/" rel="noopener noreferrer" target="_blank">
                    Cookies &amp; Privacy
                </a>
            </span>
        </div>
        <div className="grid-content center-content"></div>
        <div className="grid-content right-content">
            <span>
                {/* powered by{' '}
                <a href="https://outthink.io" rel="noopener noreferrer" target="_blank">
                    outthink.io
                </a> */}
                © 2020 OutThink
            </span>
        </div>
    </Footer>
);

const Footer = styled(HeaderFooter)`
    .grid-content span {
        font-size: 80%;
        white-space: nowrap;
    }
`;
